'use strict';

var debugEnum = require('spotify-debug-tools/debug_enum');

/**
 * Status Family for HTTP Responses.
 *
 * @enum {number}
 */
var StatusFamily = {
  /* @deprecated */
  BROWSER_ERROR: 0,
  CONNECTION_ERROR: 0,
  INFORMATIONAL: 1,
  SUCCESS: 2,
  REDIRECTION: 3,
  CLIENT_ERROR: 4,
  SERVER_ERROR: 5
};

module.exports = debugEnum(StatusFamily);
